import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { AppLayoutComponent } from "./shared/components/layout/app.layout.component";
import { LoginGuard } from './shared/guards/login.guard';
import {environment} from "../environments/environment.dev";
import {QrpageComponent} from "./pages/qrpage/qrpage.component";


// Function to conditionally include the promo route
function getPromoRoute() {
    const promoEnabled = window.localStorage.getItem('promo_enabled') === 'true';
    
    if (promoEnabled) {
        return [{ 
            path: 'promo', 
            loadChildren: () => import('../app/pages/public/public-pormo-dashboard/public-promo-dashboard/public-promo-dashboard.module').then(m => m.PublicPromoDashboardModule)
        }];
    } else {
        return [];
    }
}

@NgModule({
    imports: [
        RouterModule.forRoot([
            { 
                path: 'login', 
                loadChildren: () => import('../app/pages/auth/auth.module').then(m => m.AuthModule),
                canActivate: [LoginGuard]
            },
            { 
                path: 'set-password', 
                loadChildren: () => import('../app/pages/set-password/set-password.module').then(m => m.SetPasswordModule)
            },
            { 
                path: 'reset-password', 
                loadChildren: () => import('../app/pages/reset-password/components/reset-password/reset-password.module').then(m => m.ResetPasswordModule)
            },
            { 
                path: 'promo', 
                loadChildren: () => import('../app/pages/public/public-pormo-dashboard/public-promo-dashboard/public-promo-dashboard.module').then(m => m.PublicPromoDashboardModule)
            },
            {
                path: 'qr-access',
                loadComponent: () => import('../app/pages/qrpage/qrpage.component').then(m => m.QrpageComponent)
            },
            // ...getPromoRoute(), // Conditionally add the promo route
            {
                path: '', component: AppLayoutComponent,
                children: [
                    { path: 'dashboard', loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule) },
                    { path: '', loadChildren: () => import('../app/pages/pages.module').then(m => m.PagesModule) }
                ]
                // canActivate: []
            },
            { path: 'notfound', component: NotfoundComponent },
            { path: '**', redirectTo: '/login' },
        ], { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
